<template>
	<div class='select-wrapper'>
		<VueMultiselect
			:value='value'
			:options='options'
			:label='label'
			:trackBy='trackBy'
			:showLabels='showLabels'
			:placeholder='placeholder'
			:multiple='multiple'
			:closeOnSelect='!multiple'
			:loading='loading'
			:disabled='disabled'

			@input='onInput'
			@select='onSelect'
			@remove='onRemove'
			@open='onOpen'
			@close='onClose'
		>

			<template #noResult>Не найдено</template>
			<template #noOptions>Нет элементов</template>

			<template #tag='slotProps' v-if='multiple'>
				<!-- установка запятой после каждого выбранного элемента, кроме последнего -->
				<span class='multiselect__multiple' >{{ slotProps.option[label] + (value[value.length - 1][trackBy] !== slotProps.option[trackBy] ? ', ' : '')   }}</span>
			</template>

			<template #option='slotProps' v-if='multiple'>
				<div class='option-slot-block'>
					<input type='checkbox' :checked='isSelected(slotProps.option)'>
					<span :class='{ "empty-option": slotProps.option.isEmpty }'>{{ slotProps.option.name }}</span>
				</div>
			</template>

			<template #clear>
	      <div
	      	class="multiselect__clear"
	      	v-show="(multiple && value.length) || (!multiple && value)"
	      	@mousedown.prevent.stop="clearAll"
	      ></div>
	    </template>



		</VueMultiselect>
	</div>
</template>

<script>
	import VueMultiselect from 'vue-multiselect';
	// import 'vue-multiselect/dist/vue-multiselect.min.css';

	export default {
		name: 'VSelect',

		components: { VueMultiselect },

		props: {
			value: null, /* null - любой тип */
			options: { type: Array, default: () => [], require: true },
			trackBy: { type: String, default: 'id' },
			// trackBy: { type: String, default: null },
			label: { type: String, default: 'name' },
			// label: { type: String, default: null },
			// placeholder: { type: String, default: '' },
			multiple: { type: Boolean, default: false },
			loading: { type: Boolean, default: false },

			showLabels: { type: Boolean, default: false },

			disabled: { type: Boolean, default: false }
		},

		data: () => ({
			placeholderSearchMode: false,
		}),

		computed: {
			placeholder() {
				const placeholderRegular = this.multiple ? 'выберите значения' : 'выберите значение';
				const placeholderSearch = 'поиск...';

				return this.placeholderSearchMode ? placeholderSearch : placeholderRegular;
			}
		},

		methods: {
			onInput(value) {
				this.$emit('input', value);
			},

			onSelect(option) {
				// option.selected = true;
			},
			onRemove(option) {
				// delete option.selected;
			},

			onOpen() {
				this.placeholderSearchMode = true;
			},
			onClose() {
				this.placeholderSearchMode = false;
			},

			clearAll() {
				const clearValue = this.multiple ? [] : null;
				this.$emit('input', clearValue);
			},

			isSelected(option) {
				if (this.multiple) {
					return this.value.find(item => item[this.trackBy] === option[this.trackBy]);
				}
			}

		}
	}
</script>

<style scoped>

.option-slot-block {
	display: flex;
	align-items: center;
}

.option-slot-block > input {
	margin-right: 1rem;
}

.select-wrapper >>> .multiselect {
	font-size: 0.9rem;
	min-height: 28px;
}

.select-wrapper >>> .multiselect--disabled .multiselect__tags {
	background-color: #ededed;
}

.select-wrapper >>> .multiselect__tags {
	border: 1px solid #aaa;
	font-size: 0.9rem;
	min-height: 28px;
	padding: 3px 40px 3px 3px;
}
.select-wrapper >>> .multiselect__placeholder {
	min-height: 22px;
	font-size: inherit;
	margin-bottom: 0;
	line-height: 20px;
	padding-left: 5px;
	padding-top: 1px;
}
.select-wrapper >>> .multiselect__input {
	min-height: 22px;
	font-size: inherit;
	margin-bottom: 0px;
}
.select-wrapper >>> .multiselect__input::placeholder {

	color: #777;
}
.select-wrapper >>> .multiselect__single {
	font-size: inherit;
	margin-bottom: 0;
	min-height: 20px;
	padding-top: 2px;
	/*padding-bottom: 3px;*/
	/*overflow: hidden;*/
	/*white-space: nowrap;*/
}

.multiselect__multiple {
	/*display: inline-block;*/
	font-size: inherit;
	margin-bottom: 3px;
	min-height: 20px;
	padding-top: 2px;

}

/*.multiselect__multiple1 {
	color: blue;
}*/

.select-wrapper >>> .multiselect__tags {
	font-size: inherit;
	/*margin-bottom: 3px;*/
	line-height: 22px;
	padding-left: 5px;
	/*overflow: hidden;*/
	/*white-space: nowrap;*/
}

.empty-option {
	color: #aaa;
}

/* spinner & arrow*/

.select-wrapper >>> .multiselect__spinner {
	height: 24px;
	top: 3px;
	width: 30px;
	right: 1px;
}

.select-wrapper >>> .multiselect__spinner::after,
.select-wrapper >>> .multiselect__spinner::before {
	width: 10px;
	height: 10px;
}

.select-wrapper >>> .multiselect__select {
	width: auto;
	/*height: 100%;*/
	height: 30px;
	/*padding: 6px 8px;*/
}

/*multiple*/
.select-wrapper >>> .multiselect__tag {
	font-size: inherit;
	margin-bottom: 0;
}

/* dropdown */
.select-wrapper >>> .multiselect__option {
	padding: 8px 12px;
	min-height: 0;
	vertical-align: middle;
}

.select-wrapper >>> .multiselect__option--highlight {
	background-color: #b3cccc;
	/*background-color: #80c1ff;*/
	color: #35495e;
	
}

.select-wrapper >>> .multiselect__option--highlight.multiselect__option--selected {
	background-color: #85adad;
}

/* clear */
.select-wrapper >>> .multiselect__clear {
  position: absolute;
  right: 32px;
  /*height: 30px;*/
  /*width: 30px;*/
  display: block;
  cursor: pointer;
  /*top: 65%;*/
  z-index: 2;
  /*height: 100%;*/
  /*display: flex;*/
  /*align-items: center;*/
}
.select-wrapper >>> .multiselect__clear::before {
  transform: rotate(45deg);
}
.select-wrapper >>> .multiselect__clear::after {
  transform: rotate(-45deg);
}
.select-wrapper >>> .multiselect__clear::after,
.select-wrapper >>> .multiselect__clear::before {
  content: "";
  display: block;
  position: absolute;
  width: 2px;
  height: 12px;
  background: #aaa;
  top: 10px;
  right: 0;
  /*top: 65%;*/
}

</style>